import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getDashboardPath } from '../../utils/navigationUtils';
import { LoadingSpinner } from '../LoadingSpinner';

interface PublicRouteProps {
    children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();


    if (loading) {
        return (
            <div className="flex-1 flex items-center justify-center min-h-[100dvh]">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (user) {
        const redirectPath = getDashboardPath(user.role);
        return <Navigate to={redirectPath} replace />;
    }

    return <>{children}</>;
};
